module.exports = __webpack_public_path__ + "static/mockup.2efe42d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing/mockup.png
// module id = 134
// module chunks = 35783957827783 214309784101587